// @core/api/endpoints/booking/get_booking_numbering_scheme.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookingNumberingSchemeResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Get numbering scheme
 * Returns a booking numbering scheme by ID.
 */
export async function GetBookingNumberingScheme(
  scheme_id: string,
  options?: RequestOptions
): Promise<BookingNumberingSchemeResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/booking-numbering-schemes/:scheme_id`;
  requestPath = requestPath.replace(':scheme_id', encodeURIComponent(scheme_id));
  const requestOptions = options;
  return client.get<BookingNumberingSchemeResponse>(requestPath, { ...requestOptions });
}
